import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://29d285638fcfc799487834b304eaa952@o4511490517237760.ingest.us.sentry.io/4511490521038848",
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
  enabled: import.meta.env.PROD,
  // Ignore noisy errors that originate outside our own bundle
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    "Non-Error promise rejection captured",
  ],
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-(web-)?extension:\/\//i,
    /\/signals\//i,
    /connect\.facebook\.net/i,
    /googletagmanager\.com/i,
    /google-analytics\.com/i,
  ],
  beforeSend(event) {
    const frames = event.exception?.values?.flatMap(
      (value) => value.stacktrace?.frames ?? [],
    );
    if (!frames || frames.length === 0) return event;

    // Drop events where no frame comes from our own app bundle.
    const isOwnCode = frames.some((frame) => {
      const file = frame.filename ?? "";
      if (!file || file === "<anonymous>") return false;
      return (
        file.includes("/assets/") ||
        file.includes("/src/") ||
        file.startsWith("app://")
      );
    });

    return isOwnCode ? event : null;
  },
});

createRoot(document.getElementById("root")!).render(<App />);
